import { render, staticRenderFns } from "./MySettings.vue?vue&type=template&id=bfdaed98&scoped=true&"
import script from "./MySettings.vue?vue&type=script&lang=js&"
export * from "./MySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdaed98",
  null
  
)

export default component.exports